export default [
  {
    path: "/complejidadesProyecto",
    component: () => import("@/views/complejidadesProyecto/Listar.vue"),
  },
  {
    path: "/complejidadesProyecto/crear",
    component: () => import("@/views/complejidadesProyecto/Crear.vue"),
  },
  {
    path: "/complejidadesProyecto/editar/:id",
    component: () => import("@/views/complejidadesProyecto/Editar.vue"),
  },
];
